<template>
    <div class ="posEdit-1">
      <div class ="hideFromEdit posEdit-1__1">
        <form class ="posEdit-1__2">
          <div class="inputWithIcon">
            <input type="text" placeholder="Tên danh mục" v-model="inputCategotyName" />
          <i class="fa fa-lg fa-fw" aria-hidden="true"></i>
          </div>
          <div class="inputWithIcon">
            <input type="text" placeholder="Mật khẩu token" v-model="inputToken" maxlength="6" />
          <i class="fa fa-lg fa-fw" aria-hidden="true"></i>
          </div>
          <div class ="span--style-h">
              <span class ="fs-5 ">{{notification}} </span>
          </div>
          <button @click.prevent="EditCategory" class="btn int btn-outline-primary">
            Thực hiện
          </button>
        
        </form>
      </div>
    </div>
</template>

<script>
  import {postEditCategory} from "@/components/js/VposService";
  export default {
    props: {
      item: Object
    }, 
  
    data() {
      return {  
        inputToken: "", inputCategotyName: "", notification: ""
      };
    },
    // mounted(){
    
    //   this.inputCategotyName = localStorage.getItem("categoryName");
    //    // Theo dõi sự thay đổi của localStorage
    // window.addEventListener("storage", this.handleStorageChange);
    // },
  //   beforeUnmount() {
  //   // Loại bỏ sự kiện lắng nghe trước khi component bị unmount
  //   window.removeEventListener("storage", this.handleStorageChange);
  // },
  methods:{
      async EditCategory(){
      try{
        const response = await postEditCategory(this.inputToken, this.idStore,this.item.id,this.item.catName, 1);
          console.log("response ========>"+ JSON.stringify(response));
          // {"msgCode":44,"msgContent":"Sai chữ ký!","total":0}
         // alert("response ========>"+ JSON.stringify(response));
          if(response.msgCode == 1){
             this.notification = response.msgContent;
          }else{
            this.notification = response.msgContent;
          }
          }catch(e){
              console.log("Exception e:",e);
          }
      },
      // handleStorageChange(event) {
      // if (event.key === "categoryName") {
    
      //   this.inputCategotyName = event.newValue;
      // }
    // }
     
   }
  }
</script>
<style scoped>
.posEdit-1{
  position: absolute; background: rgba(13, 13, 14, 0.52); width: 100%; min-height: 100%;
}
.posEdit-1__1{
  width: 100%; height: 100vh; z-index: 1; display: flex;  justify-content: center;
}
.posEdit-1__2{
  background-color: white;padding: 32px; border-radius: 18px; min-width: 391px; height: 239px; margin-top: 100px;
}
</style>